import React from 'react';
import { paymentStateCopy, RETRYABLE } from '../../utils/paymentState.mjs';
import './PaymentStateScreen.css';

const ICONS = {
    completed: { accent: true, paths: <polyline points="20 6 9 17 4 12" /> },
    expired: { accent: true, paths: (<><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>) },
    cancelled: { accent: false, paths: (<><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></>) },
    'not-found': { accent: false, paths: (<><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></>) },
    error: { accent: false, paths: (<><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></>) }
};

export const Brand = () => (
    <div className="pay-state-brand">
        <div className="pay-state-brand-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24"><polygon points="3 11 22 2 13 21 11 13 3 11" /></svg>
        </div>
        <span>Powered by <strong>Voyager Pro</strong></span>
    </div>
);

/**
 * variant: 'loading' | 'expired' | 'cancelled' | 'completed' | 'not-found' | 'error'
 * title/message/hint override the default client-facing copy; onRetry shows the Try again button (generic errors only unless forced).
 */
export default function PaymentStateScreen({ variant = 'error', title, message, hint, onRetry }) {
    if (variant === 'loading') {
        return (
            <div className="pay-state-page" role="status" aria-live="polite">
                <div className="pay-state-card">
                    <div className="pay-state-spinner" aria-hidden="true" />
                    <p className="pay-state-text is-last">{message || 'Loading your payment information...'}</p>
                </div>
                <Brand />
            </div>
        );
    }
    const copy = paymentStateCopy(variant, { title, message, hint });
    const icon = ICONS[copy.variant] || ICONS.error;
    const showRetry = !!onRetry && RETRYABLE.has(copy.variant);
    return (
        <div className="pay-state-page" role="alert">
            <div className={`pay-state-card${showRetry ? ' has-action' : ''}`}>
                <div className={`pay-state-icon${icon.accent ? ' is-accent' : ''}`} aria-hidden="true">
                    <svg viewBox="0 0 24 24">{icon.paths}</svg>
                </div>
                <h1 className="pay-state-title">{copy.title}</h1>
                <p className="pay-state-text">{copy.message}</p>
                <p className="pay-state-text is-last">{copy.hint}</p>
                {showRetry && <button type="button" className="pay-state-button" onClick={onRetry}>Try again</button>}
            </div>
            <Brand />
        </div>
    );
}
